import { useQuery, UseQueryOptions } from 'react-query';

import { TimeOffPlan } from 'api';

import useFetchErp from './useFetchErp';

function usePersonalPlanQuery(cdid: string, options?: UseQueryOptions<TimeOffPlan, Error>) {
  const authorisedFetch = useFetchErp();

  return useQuery<TimeOffPlan, Error>(
    ['personal-plan', cdid],
    async () => {
      const response = await authorisedFetch(`/time_off/plans/users/cdid/${cdid}`, {
        method: 'GET',
      });

      return await response.json();
    },
    options,
  );
}

export default usePersonalPlanQuery;
